import { render, staticRenderFns } from "./iconSoldOut.vue?vue&type=template&id=51cf3991"
import script from "./iconSoldOut.vue?vue&type=script&lang=js"
export * from "./iconSoldOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports